<template>
	<div>
		<div class="col-sm-12">
			<br />
			<div class="row">
				<div class="col-sm-4">
					<span>Iniciar</span>
					<appTime v-model="data.iniciar" />
				</div>
				<div class="col-sm-4">
					<span>Duração</span>
					<appTime v-model="data.duracao" />
				</div>
				<div class="col-sm-4">
					<span>Recorrência</span>
					<appTime
						v-model="data.recorrencia"
						:disabled="rec != 365"
					/>
				</div>
			</div>
			<br />
			<div class="row">
				<div class="col-sm-12">
					<span>Recorrência</span>
					<div class="well well-sm">
						<label class="radio-inline">
							<input
								type="radio"
								v-model="rec"
								value="30"
								@click="customRec(30 * 24 * 60)"
							/>
							Mês
						</label>

						<label class="radio-inline">
							<input
								type="radio"
								v-model="rec"
								value="15"
								@click="customRec(15 * 24 * 60)"
							/>
							Quinzenal
						</label>

						<label class="radio-inline">
							<input
								type="radio"
								v-model="rec"
								value="7"
								@click="customRec(7 * 24 * 60)"
							/>
							Semanal
						</label>

						<label class="radio-inline">
							<input
								type="radio"
								v-model="rec"
								value="1"
								@click="customRec(1 * 24 * 60)"
							/>
							Dia
						</label>

						<label class="radio-inline">
							<input
								type="radio"
								v-model="rec"
								value="365"
								@click="customRec(365 * 24 * 60)"
							/>
							Outro
						</label>
					</div>
				</div>
			</div>
			<div class="row" v-if="sequenciar">
				<div class="col-sm-12">
					<span>Dia</span>
					<div class="well well-sm">
						<label class="radio-inline">
							<input
								type="radio"
								value="next monday"
								v-model="data.sequencia"
							/>
							Segunda
						</label>
						<label class="radio-inline">
							<input
								type="radio"
								value="next tuesday"
								v-model="data.sequencia"
							/>
							Terça
						</label>
						<label class="radio-inline">
							<input
								type="radio"
								value="next wednesday"
								v-model="data.sequencia"
							/>
							Quarta
						</label>
						<label class="radio-inline">
							<input
								type="radio"
								value="next thursday"
								v-model="data.sequencia"
							/>
							Quinta
						</label>
						<label class="radio-inline">
							<input
								type="radio"
								value="next friday"
								v-model="data.sequencia"
							/>
							Sexta
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="clearfix"></div>
	</div>
</template>
<script>
	import appTime from 'time';

	export default {
		name: 'AppSettingsTarefa',
		props: ['dIn', 'sequenciar'],
		components: { appTime },
		computed: {
			data() {
				return this.dIn;
			},
		},
		data() {
			return {
				blockCRec: false,
				rec: 365,
			};
		},
		watch: {
			sequenciar: function (val) {
				if (val == false) this.data.sequencia = '';
			},
			'data.sequencia': function (val) {
				if (val != '') this.$emit('seq', true);
				else this.$emit('seq', false);
			},
		},
		methods: {
			customRec(dias) {
				this.data.recorrencia = dias;
				if (dias == 365 * 24 * 60) this.blockCRec = false;
				else this.blockCRec = true;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/tasks/components/configuracao.vue